module.exports = __webpack_public_path__ + "static/media/logistics.ed57ce7b.jpg";